/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable array-callback-return */
import _, { isEmpty } from 'lodash';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router';

import { Alert } from 'react-bootstrap';
import { Button, Icon, Label, List, Message, Modal } from 'semantic-ui-react';
import AmsAlert from '../../utils/AmsAlert';
import AmsSubmitReloadReportWizardPage from './AmsSubmitReloadReportWizardPage';

import pdfIcon from '../../assets/images/pdf-icon.png';

// Import components
import AmsDateFormatters from '../../utils/AmsDateFormatters';
import AmsModal from '../../utils/AmsModal';
import ReviewLayout from '../../utils/layout/ReviewLayout';
import { formatReviewPageTitle } from '../../utils/TextFormatters';
import SurveyItems from '../Survey/SurveyItems';
import ReviewShippedDetails from './FY19/ReviewInfo/ReviewShippedDetails';
import ReviewDetailCLASSItems from './ReviewDetailCLASSItems';
import { fetchAmsLookup } from '../../actions/lookupActions';

// Import actions
import {
  fetchReportDraftTemplate,
  fetchReportStatusData,
  reportSaveAction,
  surveyReportSaveAction,
} from '../../actions/reportActions';
import {
  clearReviewDetail,
  fetchEmailNotifyFOMRequest,
  fetchReviewDetail,
  fetchReviewEvidence,
  fetchReviews,
  finalizeReview,
  recreateManifestFile,
  removeMessage,
  submitToFOM,
  updateReviewStatus,
} from '../../actions/reviewActions';
import {
  downloadClassSamplingReport,
  fetchClassReviewDetail,
  freezAdhocReport,
  getClassSamplingReport,
  runAdHocSampleGenerate,
} from '../../actions/submissions';
import { finalizeSurveys } from '../../actions/surveyActions';

// Import helper function.
import enforceRole from '../../utils/EnforceRole';

// Import acl.
import { acl, focusAreaReviewTypes } from '../../config';

import './assets/style.css';

class ReviewDetailPage extends Component {
  constructor() {
    super();

    this.state = {
      manifestRecreating: false,
      adhocGenerating: false,
      showAlert: false,
      showFomAlert: false,
      showSuccessAlert: false,
      showRecreateSuccessAlert: false,
      selectedSurveys: [],
      responseErrors: [],
      showMoreClassSamplingReport: false,
      showSubmitToManagerModal: false,
      selectedManagerList: [],
      showEmailAlert: false,
      result: '',
      showFreezeSampleWarningFlag: false,
      classSampleFreezing: false,
      freezAdhocRptStatus: false,
      freezButtonEnabled: true,
      freezDate: AmsDateFormatters.getMoment().startOf('day'),
      classVideoUrl: '',
    };
  }

  componentDidMount() {
    this.getData();
    const reviewId = this.context.router.params.id;
    this.props
      .fetchReviewDetail({ reviewId })
      .then(response => {
        const { selectedReview } = this.props;
        if (
          selectedReview.newFAFlowFlag ||
          selectedReview.reviewType === 'RAN' ||
          selectedReview.reviewType === 'Follow-up' ||
          selectedReview.reviewType === 'AIAN-DEF Reeval' ||
          selectedReview.systemName === 'OHSMS'
        ) {
          const path = this.context.router.location.pathname;
          const fyPath = 'fy' + selectedReview.fiscalYear.toString().slice(-2);

          // Redirect to new fy19 review detail page if newFAFlowFlag is available
          if (path && !path.includes(fyPath))
            this.context.router.push(
              `/review/${fyPath}/${selectedReview.reviewId}`
            );
          return;
        }
        this.setState({
          freezButtonEnabled: response.review.freezButtonEnabled,
          freezAdhocRptStatus: response.review.freezAdhocRpt,
          freezDate: response.review.freezDate,
        });

        this.props.getClassSamplingReport({ reviewId });
        this.props.fetchReviewEvidence({ filters: { reviewId } });
      })
      .catch(error => {
        this.setState({
          responseErrors: [
            ...this.state.responseErrors,
            (error.response || { data: Error('unknown error') }).data,
          ],
        });
      });

    this.reportDraftTemplateRequested = false;
  }

  getData = () => {
    const { fetchAmsLookup, amsLookups } = this.props;
    const category = 'irisConnectVideoLink';
    fetchAmsLookup(category).then(response => {
      const childLookupObj = _.find(response.lookups, { parent: false });
      if (childLookupObj.value?.value) {
        this.setState({
          classVideoUrl: childLookupObj.value?.value,
        });
      }
    });
  };

  componentWillReceiveProps() {
    if ((this.props.selectedReview || {}).reviewId && !this.reportInfoReq) {
      this.reportInfoReq = true;
      this.props.fetchReportStatusData(
        (this.props.selectedReview || {}).reviewId
      );
    }
  }

  componentWillUnmount() {
    this.props.clearReviewDetail();
  }

  renderSurveyItems() {
    const { selectedReview } = this.props;
    return selectedReview.reviewId && <SurveyItems />;
  }

  handleModalClick = () => {
    this.setState({
      showSubmitToManagerModal: true,
    });
  };

  handleModalClosure = value => {
    this.setState({
      showSubmitToManagerModal: value,
    });
  };

  renderCLASSItems = () => {
    const { selectedReview } = this.props;
    const params = {
      reviewId: this.context.router.params.id,
      grantee: selectedReview.grantees,
    };
    return (
      selectedReview.reviewId && (
        <ReviewDetailCLASSItems
          content={(this.props.reportDraftTemplate || {}).content}
          params={params}
        />
      )
    );
  };

  renderGrantees(selectedReview) {
    const { grantees, precedingGranteeId } = selectedReview;

    // const inActiveGranteeList = filter(grantees, grantee => {
    //   return grantee.granteeStatus !== 'Active';
    // });

    const firstGrantee = grantees[0] || [];
    return (
      <div className="col-sm-12 review-detail">
        <div className="grantee-item">
          {firstGrantee.granteeName && (
            <div>
              <span
                role="heading"
                aria-level="2"
                className="field-title"
                aria-label="Grantee Name"
              >
                Grantee Name:{' '}
              </span>{' '}
              <Link
                to={`/grantee/${firstGrantee.granteeId}`}
              >{` ${firstGrantee.granteeName} (${firstGrantee.granteeId})`}</Link>
            </div>
          )}
          {precedingGranteeId && (
            <div>
              <span
                role="heading"
                aria-level="2"
                className="field-title"
                aria-label="Preceding Grantee ID"
              >
                Preceding Grantee ID:{' '}
              </span>{' '}
              <Link to={`/grantee/${precedingGranteeId}`}>
                {precedingGranteeId}
              </Link>
            </div>
          )}
          {selectedReview.reviewType && (
            <div>
              <span
                role="heading"
                aria-level="2"
                className="field-title"
                aria-label="Review Type"
              >
                Review Type:{' '}
              </span>{' '}
              {` ${selectedReview.reviewType}`}{' '}
              {selectedReview.reviewTypeDefinition &&
                `(${selectedReview.reviewTypeDefinition})`}
            </div>
          )}
          {selectedReview.reviewDataCollection && (
            <div>
              <span
                role="heading"
                aria-level="2"
                className="field-title"
                aria-label="Data Collection"
              >
                Data Collection:{' '}
              </span>{' '}
              {selectedReview.reviewDataCollection}
            </div>
          )}
          {selectedReview.reviewStatus && (
            <div>
              <span
                role="heading"
                aria-level="2"
                className="field-title"
                aria-label="Review Status"
              >
                Review Status:{' '}
              </span>{' '}
              {selectedReview.reviewStatus}
            </div>
          )}
          {selectedReview.reviewOutcome && (
            <div>
              <span
                role="heading"
                aria-level="2"
                className="field-title"
                aria-label="Review Outcome"
              >
                Review Outcome:{' '}
              </span>{' '}
              {selectedReview.reviewOutcome}
            </div>
          )}
          {firstGrantee.region && (
            <div>
              <span
                role="heading"
                aria-level="2"
                className="field-title"
                aria-label="Region"
              >
                Region:{' '}
              </span>{' '}
              {firstGrantee.region}
            </div>
          )}
          <div>
            <span
              role="heading"
              aria-level="2"
              className="field-title"
              aria-label="State"
            >
              State:{' '}
            </span>{' '}
            {firstGrantee.state && firstGrantee.state}
          </div>
          {firstGrantee.agencyId && (
            <div>
              <span
                role="heading"
                aria-level="2"
                className="field-title"
                aria-label="Agency ID"
              >
                Agency ID:{' '}
              </span>{' '}
              {firstGrantee.agencyId}
            </div>
          )}
          {selectedReview.numberOfGrants && (
            <div>
              <span
                role="heading"
                aria-level="2"
                className="field-title"
                aria-label="Number of grants in this review"
              >
                Number of grants in this review:{' '}
              </span>{' '}
              {selectedReview.numberOfGrants}
            </div>
          )}
        </div>

        <ul className="grantee-list">
          {grantees.map((grantee, index) => {
            // Ignore the first one because it's shown above with it's full detail.
            if (index > 0)
              return (
                grantee.granteeName && (
                  <li className="grantee-item" key={index}>
                    <span
                      role="heading"
                      aria-level="3"
                      className="field-title"
                      aria-label="Grantee Name"
                    >
                      Grantee Name:{' '}
                    </span>{' '}
                    <Link
                      to={`/grantee/${grantee.granteeId}`}
                    >{` ${grantee.granteeName} (${grantee.granteeId})`}</Link>
                  </li>
                )
              );
          })}
        </ul>
      </div>
    );
  }

  renderEditButton = () => {
    const { selectedReview, currentUser } = this.props;
    const reviewStatuses = ['Cancelled', 'Shipped'];
    if (
      selectedReview &&
      selectedReview.reviewStatus &&
      reviewStatuses.includes(selectedReview.reviewStatus)
    )
      return null;

    return enforceRole(
      <Button
        color="green"
        content="Edit Review"
        size="large"
        onClick={this.handleEdit}
      />,
      acl.actions.review.update, // Allowed roles
      currentUser.roles // Current user roles
    );
  };

  handleEdit = () => {
    const { selectedReview } = this.props;
    this.context.router.push({
      pathname: `/review/${this.context.router.params.id}/edit`,
      state: { selectedReview: selectedReview, edit: true },
    });
  };

  downloadClassSamplingReport = reportFile => {
    this.props.downloadClassSamplingReport(reportFile);
  };

  showMoreClassSamplingReports = () => {
    const { classSamplingReportList } = this.props;
    return (
      <AmsModal
        className="ams-semantic-modal-fix"
        size="small"
        open={this.state.showMoreClassSamplingReports}
        closeOnEscape={true}
      >
        <Modal.Header>Class Sampling Reports</Modal.Header>
        <Modal.Content>
          {classSamplingReportList.length &&
            classSamplingReportList.map((reportFile, index) => {
              return (
                <li key={index}>
                  <a
                    href=""
                    onClick={event => {
                      event.preventDefault();
                      this.downloadClassSamplingReport(reportFile);
                    }}
                  >
                    Download Sampling Report File ({reportFile})
                  </a>
                </li>
              );
            })}
        </Modal.Content>
        <Modal.Actions>
          <Button
            onClick={() => {
              this.setState({ showMoreClassSamplingReports: false });
            }}
          >
            Close
          </Button>
        </Modal.Actions>
      </AmsModal>
    );
  };

  generateAdhocAlertBanner = () => {
    const { selectedReview, currentUser } = this.props;
    const { adhocGenerating } = this.state;

    const style = {
      boldInfo: {
        fontFamily: 'PublicSans-Bold',
      },
    };
    const disabled =
      adhocGenerating ||
      !selectedReview.reviewStatus ||
      selectedReview.reviewStatus.toLowerCase() === 'cancelled' ||
      (this.props.selectedReview || {}).reportStage === 'signed'
        ? 'hidden'
        : 'visible';

    const generatedAfterReplacement =
      AmsDateFormatters.getMoment(selectedReview.fileUploadedDate).isBefore(
        AmsDateFormatters.getMoment(selectedReview.granteeReplacementDate)
      ) && selectedReview.precedingGranteeId !== '';

    if (
      (selectedReview.reviewType === 'CLASS' ||
        selectedReview.reviewType === 'AIAN-CLASS Reeval' ||
        selectedReview.reviewType === 'PR-CLASS' ||
        selectedReview.reviewType === 'VP-CLASS' ||
        selectedReview.reviewType === 'CLASS-Video' ||
        selectedReview.reviewType === 'AIAN CLASS Self-Observations' ||
        selectedReview.reviewType === 'CLASS AIAN Onsite' ||
        selectedReview.reviewType === 'CLASS AIAN Video') &&
      generatedAfterReplacement
    )
      return enforceRole(
        <Message style={style.boldInfo} info>
          <Icon name="info" />
          <span>
            Note: The CLASS samples have not been regenerated since the grantee
            has been replaced. Would you like to regenerate?{' '}
            <Link
              href="#"
              style={{ visibility: disabled }}
              onClick={e => {
                e.preventDefault();
                this.setState({ showGenerateAdHocWarningFlag: true });
              }}
            >
              Yes, regenerate
            </Link>
          </span>
        </Message>,
        acl.actions.adhoc.generate,
        currentUser.roles
      );
  };

  freezeSampleBanner = () => {
    const { selectedReview } = this.props;
    const { freezAdhocRptStatus, freezDate } = this.state;
    if (
      selectedReview &&
      freezAdhocRptStatus &&
      (selectedReview.reviewType === 'CLASS' ||
        selectedReview.reviewType === 'AIAN-CLASS Reeval' ||
        selectedReview.reviewType === 'PR-CLASS' ||
        selectedReview.reviewType === 'VP-CLASS' ||
        selectedReview.reviewType === 'CLASS-Video' ||
        selectedReview.reviewType === 'AIAN CLASS Self-Observations' ||
        selectedReview.reviewType === 'CLASS AIAN Onsite' ||
        selectedReview.reviewType === 'CLASS AIAN Video')
    )
      return (
        <Message info>
          <Icon name="info" />
          <span>
            The CLASS Sample auto-generation process has been frozen as of{' '}
            {AmsDateFormatters.getMoment(freezDate)
              .startOf('day')
              .format('MM/DD/YYYY')}
          </span>
        </Message>
      );
  };

  generateFY18EvidenceBanner = () => {
    const { selectedReview } = this.props;

    if (!selectedReview || selectedReview.fiscalYear !== 2018) {
      return;
    }

    return (
      <Message info>
        <Icon name="info" />
        <span>
          Note: Access all evidence files (attachments) from the evidence binder
          page.{' '}
          <Link href={`/review/${selectedReview.reviewId}/evidence-binder`}>
            Click to visit.
          </Link>
        </span>
      </Message>
    );
  };

  renderReviewDetail() {
    const { selectedReview, currentUser, classSamplingReportList } = this.props;
    const { adhocGenerating, classSampleFreezing } = this.state;
    const { showSubmitToManagerModal } = this.state;

    const reportButtonText = ((this.props || {}).report.reportStatusData || {})
      ._id
      ? 'Reload Report'
      : 'Submit to Manager';

    //if the review start date is in the future and the status is "Submit to Manager"
    //disable the button
    const invalidDate =
      !AmsDateFormatters.getMoment(selectedReview.startDate)
        .startOf('day')
        .isSameOrBefore(AmsDateFormatters.getMoment().startOf('day')) &&
      reportButtonText === 'Submit to Manager';

    return (
      <div>
        {this.generateAdhocAlertBanner()}
        {this.generateFY18EvidenceBanner()}
        {this.freezeSampleBanner()}
        <div className="col-sm-6">
          {selectedReview.grantees && this.renderGrantees(selectedReview)}

          {selectedReview.startDate && (
            <div className="col-sm-12 review-detail">
              <div>
                <span
                  role="heading"
                  aria-level="2"
                  className="field-title"
                  aria-label="Start Date"
                >
                  Start Date:{' '}
                </span>{' '}
                {AmsDateFormatters.formatDate(selectedReview.startDate)}
              </div>
            </div>
          )}

          {selectedReview.endDate && (
            <div className="col-sm-12 review-detail">
              <div>
                <span
                  role="heading"
                  aria-level="2"
                  className="field-title"
                  aria-label="End Date"
                >
                  End Date:{' '}
                </span>{' '}
                {AmsDateFormatters.formatDate(selectedReview.endDate)}
              </div>
            </div>
          )}

          {(selectedReview.reviewType === 'CLASS-Video' ||
            selectedReview.reviewType === 'CLASS AIAN Video') && (
            <div className="col-sm-12 review-detail">
              <div>
                <a href={this.state.classVideoUrl} target="/">
                  Select to view CLASS Video Recordings
                </a>
              </div>
            </div>
          )}

          {(selectedReview.reviewType === 'CLASS' ||
            selectedReview.reviewType === 'AIAN-CLASS Reeval' ||
            selectedReview.reviewType === 'PR-CLASS' ||
            selectedReview.reviewType === 'VP-CLASS' ||
            selectedReview.reviewType === 'CLASS-Video' ||
            selectedReview.reviewType === 'AIAN CLASS Self-Observations' ||
            selectedReview.reviewType === 'CLASS AIAN Onsite' ||
            selectedReview.reviewType === 'CLASS AIAN Video') && (
            <div className="col-sm-12 review-detail">
              {selectedReview.showClassSamplingReport &&
                classSamplingReportList && (
                  <span
                    role="heading"
                    aria-level="2"
                    className="field-title"
                    aria-label="CLASS Sample Report"
                  >
                    CLASS Sample Report:
                  </span>
                )}
              {!adhocGenerating &&
                selectedReview.showClassSamplingReport &&
                classSamplingReportList.length >= 1 && (
                  <div>
                    <a
                      href=""
                      onClick={event => {
                        event.preventDefault();
                        this.downloadClassSamplingReport(
                          classSamplingReportList[0]
                        );
                      }}
                    >
                      <img
                        alt="PDF icon"
                        className="manifest-pdf-icon"
                        src={pdfIcon}
                      />
                      Download Sampling Report File (
                      {classSamplingReportList[0]})
                    </a>
                  </div>
                )}
              &nbsp; &nbsp;
              {selectedReview.showClassSamplingReport &&
                classSamplingReportList &&
                classSamplingReportList.length > 1 &&
                enforceRole(
                  <Button
                    disabled={adhocGenerating}
                    onClick={() => {
                      this.setState({ showMoreClassSamplingReports: true });
                    }}
                    size="small"
                    primary
                  >
                    {'All CLASS Sample Reports'}{' '}
                  </Button>,
                  acl.actions.adhoc.downloadSampleReport,
                  currentUser.roles
                )}
              <ReviewShippedDetails />
            </div>
          )}
        </div>
        <div style={{ marginTop: '40px' }} className="col-sm-6 text-right">
          {selectedReview.unannounced && (
            <Label size="large" circular color="orange">
              Unannounced
            </Label>
          )}
        </div>
        <div style={{ marginTop: '10px' }} className="col-sm-6 text-right">
          {(selectedReview.reviewType === 'CLASS' ||
            selectedReview.reviewType === 'AIAN-CLASS Reeval' ||
            selectedReview.reviewType === 'PR-CLASS' ||
            selectedReview.reviewType === 'VP-CLASS' ||
            selectedReview.reviewType === 'CLASS-Video' ||
            selectedReview.reviewType === 'AIAN CLASS Self-Observations' ||
            selectedReview.reviewType === 'CLASS AIAN Onsite' ||
            selectedReview.reviewType === 'CLASS AIAN Video') &&
          this.props.reportDraftTemplate &&
          selectedReview.reviewStatus &&
          selectedReview.reviewStatus !== 'Cancelled' ? (
            <div className="pull-right">
              {enforceRole(
                <AmsModal
                  className="ams-semantic-modal-fix"
                  size="small"
                  open={showSubmitToManagerModal}
                  trigger={
                    <Button
                      disabled={
                        (this.props.selectedReview || {}).reportStage ===
                          'signed' ||
                        (this.props.selectedReview || {}).reportStage ===
                          'finalized' ||
                        invalidDate ||
                        isEmpty([
                          ...selectedReview.managerList,
                          ...selectedReview.editorList,
                          ...selectedReview.technicalWriterList,
                          ...selectedReview.analystList,
                          ...selectedReview.followupLeadList,
                        ])
                      }
                      primary
                      onClick={this.handleModalClick}
                      content={reportButtonText}
                    />
                  }
                >
                  <Modal.Content>
                    {
                      <AmsSubmitReloadReportWizardPage
                        selectedReview={selectedReview}
                        content={(this.props.reportDraftTemplate || {}).content}
                        {...this.props}
                        data={{
                          handleModalClosure: this.handleModalClosure,
                        }}
                      />
                    }
                  </Modal.Content>
                </AmsModal>,
                acl.actions.classDetailButtons.submitToFOM,
                currentUser.roles
              )}
            </div>
          ) : (
            enforceRole(
              <i />,
              acl.actions.classDetailButtons.draftReport,
              currentUser.roles
            )
          )}
          <br />
          {selectedReview.enableFinalizeReview && (
            <Button
              onClick={this.handleFinalizeReviewClick.bind(this)}
              className="finalize-button"
            >
              {' '}
              Finalize Review Data
            </Button>
          )}
          {this.showApprovalStatus()}
          <br />
          <br />
          <br />
          {(selectedReview.reviewType === 'CLASS' ||
            selectedReview.reviewType === 'AIAN-CLASS Reeval' ||
            selectedReview.reviewType === 'PR-CLASS' ||
            selectedReview.reviewType === 'VP-CLASS' ||
            selectedReview.reviewType === 'CLASS-Video' ||
            selectedReview.reviewType === 'AIAN CLASS Self-Observations' ||
            selectedReview.reviewType === 'CLASS AIAN Onsite' ||
            selectedReview.reviewType === 'CLASS AIAN Video') &&
            enforceRole(
              <span>
                <Button
                  disabled={
                    adhocGenerating ||
                    selectedReview.reviewStatus.toLowerCase() === 'cancelled' ||
                    (this.props.selectedReview || {}).reportStage === 'signed'
                  }
                  style={{ float: 'right' }}
                  className="ui medium button blue"
                  onClick={() => {
                    this.setState({ showGenerateAdHocWarningFlag: true });
                  }}
                >
                  {adhocGenerating ? 'Generating...' : 'Generate ADHOC Sample'}{' '}
                </Button>
                <br />
                <br />
              </span>,
              acl.actions.adhoc.generate,
              currentUser.roles
            )}
          <br />
          <br />
          <br />
          {(selectedReview.reviewType === 'CLASS' ||
            selectedReview.reviewType === 'AIAN-CLASS Reeval' ||
            selectedReview.reviewType === 'PR-CLASS' ||
            selectedReview.reviewType === 'VP-CLASS' ||
            selectedReview.reviewType === 'CLASS-Video' ||
            selectedReview.reviewType === 'AIAN CLASS Self-Observations' ||
            selectedReview.reviewType === 'CLASS AIAN Onsite' ||
            selectedReview.reviewType === 'CLASS AIAN Video') &&
            enforceRole(
              <span>
                <Button
                  disabled={
                    classSampleFreezing || !this.state.freezButtonEnabled
                  }
                  style={{ float: 'right' }}
                  className="ui medium button blue"
                  onClick={() => {
                    this.setState({ showFreezeSampleWarningFlag: true });
                  }}
                >
                  {classSampleFreezing ? 'Freezing...' : 'Freeze Sample'}{' '}
                </Button>
                <br />
                <br />
              </span>,
              acl.actions.adhoc.generate,
              currentUser.roles
            )}
        </div>

        <div className="col-sm-12 survey-items">
          {selectedReview.reviewType === 'Follow-up' &&
          this.props.reportDraftTemplate ? (
            <div className="pull-right">
              {enforceRole(
                <button
                  className="btn btn-primary"
                  onClick={() => {
                    let content = this.props.reportDraftTemplate.content;
                    try {
                      // fix encoding
                      content = decodeURIComponent(escape(content));
                    } catch (err) {}
                    let htmlPage =
                      // eslint-disable-next-line no-multi-str
                      '<!DOCTYPE html>\n\
                <head>\n\
                  <meta charset="utf-8">\n\
                  <base href="' +
                      window.location.href +
                      // eslint-disable-next-line no-multi-str
                      '">\n\
                  <title>Report Preview</title>\n\
                  ' +
                      (() => {
                        return Array.prototype.slice
                          .call(document.getElementsByTagName('style'))
                          .map(style => {
                            return (
                              '<style type="text/css">' +
                              style.textContent +
                              '</style>'
                            );
                          })
                          .join('\n');
                      })() +
                      // eslint-disable-next-line no-multi-str
                      '\n\
                  ' +
                      (() => {
                        return Array.prototype.slice
                          .call(document.getElementsByTagName('link'))
                          .filter(link => {
                            return link.getAttribute('rel') === 'stylesheet';
                          })
                          .map(link => {
                            return link.getAttribute('href');
                          })
                          .filter(url => {
                            return !!url;
                          })
                          .map(url => {
                            // eslint-disable-next-line no-useless-escape
                            if (!url.match(/^http(s|)\:\/\//))
                              return window.location.origin + url;
                            return url;
                          })
                          .map(url => {
                            return (
                              '<link type="text/css" rel="stylesheet" href="' +
                              url +
                              '">'
                            );
                          })
                          .join('\n');
                      })() +
                      // eslint-disable-next-line no-multi-str
                      '\n\
                </head>\n\
                <body>' +
                      // eslint-disable-next-line no-multi-str
                      '<div class="review-preview-template">\
                    <div class="review-preview-template--bg animated fadeIn"></div>\
                    <div class="review-preview-template--container animated slideInRight">\
                       <div class="review-preview-template--content" review-id="' +
                      this.props.selectedReview.reviewId +
                      // eslint-disable-next-line no-multi-str
                      '">\
                         <button class="btn btn-sm btn-primary review-preview-template--close" onclick="window.close()">Close</button>\
                         <div class="report-item--content">' +
                      content +
                      // eslint-disable-next-line no-multi-str
                      '</div>\
                                             </div>\
                                          </div>\
                                        </div>' +
                      // eslint-disable-next-line no-multi-str
                      '\n\
                </body>\n\
                </html>';
                    let blob = new Blob([htmlPage], { type: 'text/html' });
                    let url = URL.createObjectURL(blob);
                    window.open(
                      url,
                      'preview-template',
                      'width=' +
                        Math.ceil(window.screen.width * 0.8) +
                        ',height=' +
                        Math.ceil(window.screen.height * 0.8)
                    );
                  }}
                >
                  Draft Report
                </button>,
                acl.actions.classDetailButtons.draftReport,
                currentUser.roles
              )}
              &nbsp;&nbsp;
              {enforceRole(
                <button
                  className="btn btn-primary"
                  onClick={() => {
                    let selectedReview = this.props.selectedReview;
                    let content = this.props.reportDraftTemplate.content;
                    const validReviewTypes = ['FA2-CR', 'FA1-FR'];
                    const newFormReviewTypes = [
                      'RAN',
                      'Special',
                      'AIAN-DEF Reeval',
                    ];
                    const input = {
                      reviewID: selectedReview.reviewId,
                      reportContent: content,
                      reportStatus: '',
                      versionStatus: 'draft',
                      who: this.props.currentUser.oid,
                      versionNumber: '0.01',
                      reportRegenerated: false,
                      when: new Date()
                        .toISOString()
                        .replace(/\.\d{1,3}Z$/, '-0400'),
                    };
                    if (
                      validReviewTypes.includes(selectedReview?.reviewType) ||
                      focusAreaReviewTypes.includes(
                        selectedReview?.reviewType
                      ) ||
                      (newFormReviewTypes.includes(
                        selectedReview?.reviewType
                      ) &&
                        selectedReview?.isNewForms)
                    ) {
                      this.props.surveyReportSaveAction(input);
                    } else {
                      this.props.reportSaveAction(input);
                    }
                    this.props.fetchEmailNotifyFOMRequest(
                      {
                        reviewId: selectedReview.reviewId,
                      },
                      result => {
                        if (result instanceof Error) {
                          alert(
                            'Error: ' + (result.message || 'unknown error')
                          );
                        } else {
                          alert('Notify was submitted to FOM');
                        }
                      }
                    );
                  }}
                >
                  Submit to FOM
                </button>,
                acl.actions.classDetailButtons.submitToFOM,
                currentUser.roles
              )}
            </div>
          ) : (
            enforceRole(
              <i />,
              acl.actions.classDetailButtons.draftReport,
              currentUser.roles
            )
          )}

          {selectedReview.reviewType === 'CLASS' ||
          selectedReview.reviewType === 'AIAN-CLASS Reeval' ||
          selectedReview.reviewType === 'PR-CLASS' ||
          selectedReview.reviewType === 'VP-CLASS' ||
          selectedReview.reviewType === 'CLASS-Video' ||
          selectedReview.reviewType === 'AIAN CLASS Self-Observations' ||
          selectedReview.reviewType === 'CLASS AIAN Onsite' ||
          selectedReview.reviewType === 'CLASS AIAN Video'
            ? this.renderCLASSItems()
            : selectedReview.reviewType === 'FA1-R'
            ? null
            : this.renderSurveyItems()}
        </div>
      </div>
    );
  }

  recreateManifestFile() {
    const { selectedReview } = this.props;

    if (selectedReview && selectedReview.reviewId) {
      this.setState({ manifestRecreating: true });
      this.props
        .recreateManifestFile(selectedReview.reviewId)
        .then(message => {
          this.setState({
            manifestRecreating: false,
            recreateMessage: message,
            showRecreateSuccessAlert: true,
          });
        })
        .catch(error => {
          this.setState({
            manifestRecreating: false,
            recreateMessage: '',
            showRecreateSuccessAlert: false,
            responseErrors: [...this.state.responseErrors, error.response.data],
          });
        });
    }
  }

  generateAdhoc = () => {
    const { selectedReview } = this.props;

    if (selectedReview && selectedReview.reviewId) {
      this.setState({ adhocGenerating: true });
      let input = {
        reviewId: selectedReview.reviewId,
      };
      this.props
        .runAdHocSampleGenerate(input)
        .then(data => {
          if (data) {
            this.setState({
              adhocGenerating: false,
              showAdhocGenerateAlert: true,
              adhocMessage: 'Successfully generated adhoc class samples.',
            });

            const reviewId = this.context.router.params.id;
            this.props.fetchReviewDetail({ reviewId });
          } else {
            this.setState({
              adhocGenerating: false,
              showAdhocGenerateAlert: true,
              adhocMessage:
                'Adhoc class samples were not generated. Something went wrong, please try again.',
            });
          }
        })
        .catch(error => {
          this.setState({
            adhocGenerating: false,
            adhocMessage: '',
            showAdhocGenerateAlert: false,
            responseErrors: [...this.state.responseErrors, error.response.data],
          });
        });
    }
  };

  freezeSample = () => {
    const { selectedReview } = this.props;

    if (selectedReview && selectedReview.reviewId) {
      this.setState({ classSampleFreezing: true });
      let input = {
        reviewId: selectedReview.reviewId,
      };
      this.props
        .freezAdhocReport(input)
        .then(data => {
          if (data) {
            this.setState({
              classSampleFreezing: false,
              showFreezeSampleAlert: true,
              freezeSampleMessage:
                'Successfully froze the auto-generated CLASS sample process.',
              freezButtonEnabled: data.classFreezeDetails.freezButtonEnabled,
              freezAdhocRptStatus: data.classFreezeDetails.freezAdhocRpt,
              freezDate: data.freezDate,
            });
          } else {
            this.setState({
              classSampleFreezing: false,
              showFreezeSampleAlert: true,
              freezeSampleMessage:
                'Class samples was not frozen. Something went wrong, please try again.',
            });
          }
        })
        .catch(error => {
          this.setState({
            classSampleFreezing: false,
            freezeSampleMessage: '',
            showFreezeSampleAlert: false,
            responseErrors: [...this.state.responseErrors, error.response.data],
          });
        });
    }
  };

  showApprovalStatus() {
    const { selectedReview } = this.props;
    return (
      <div className="surveys-status">
        {selectedReview.finalized && (
          <div className="surveys-status">
            <div className="survey-status-final-message">
              This review is ready for report production
            </div>
          </div>
        )}
        {(selectedReview &&
          selectedReview.reviewType !== 'FA1-R' &&
          selectedReview.reviewType !== 'CLASS' &&
          selectedReview.reviewType !== 'AIAN-CLASS Reeval' &&
          selectedReview.reviewType !== 'PR-CLASS' &&
          selectedReview.reviewType !== 'VP-CLASS' &&
          selectedReview.reviewType !== 'CLASS-Video' &&
          selectedReview.reviewType !== 'AIAN CLASS Self-Observations') ||
          selectedReview.reviewType !== 'CLASS AIAN Onsite' ||
          (selectedReview.reviewType == 'CLASS AIAN Video' && (
            <div className="survey-status-count">
              {selectedReview.submissionsApproved || 0} out of{' '}
              {selectedReview.totalSubmissions || 0}
            </div>
          ))}
        {(selectedReview &&
          selectedReview.reviewType !== 'FA1-R' &&
          selectedReview.reviewType !== 'CLASS' &&
          selectedReview.reviewType !== 'AIAN-CLASS Reeval' &&
          selectedReview.reviewType !== 'PR-CLASS' &&
          selectedReview.reviewType !== 'VP-CLASS' &&
          selectedReview.reviewType !== 'CLASS-Video' &&
          selectedReview.reviewType !== 'AIAN CLASS Self-Observations') ||
          selectedReview.reviewType !== 'CLASS AIAN Onsite' ||
          (selectedReview.reviewType !== 'CLASS AIAN Video' && (
            <div className="survey-status-message">
              Submitted Surveys have been Approved
            </div>
          ))}
      </div>
    );
  }

  showConfirmationAlert() {
    const { selectedReview } = this.props;

    if (!selectedReview.reviewId) return null;

    return (
      <AmsAlert
        show={this.state.showAlert}
        title="Finalize Review"
        text={`Are you sure you want to finalize Review: ${selectedReview.reviewId}?`}
        type={'warning'}
        confirmButtonColor={'#DD6B55'}
        confirmButtonText={'Yes, finalize it!'}
        cancelButtonText={'No, cancel'}
        showConfirm
        showCancelButton
        onCancel={() => {
          this.setState({ showAlert: false });
        }}
        onConfirm={() => {
          this.setState({ showAlert: false });
          this.props.finalizeReview({ reviewId: selectedReview.reviewId });
        }}
      />
    );
  }

  showSuccessAlert() {
    const { message } = this.props;

    if (!this.state.showSuccessAlert) return null;

    return (
      <AmsAlert
        show={this.state.showSuccessAlert || !isEmpty(message)}
        title="Review Finalized"
        type="success"
        showConfirm
        text={`This review is ready for report production.`}
        onConfirm={() => {
          this.setState({
            showSuccessAlert: false,
            showAlert: false,
          });
          this.props.removeMessage();
          this.context.router.push(`/review`);
        }}
      />
    );
  }

  showManifestRecreateSuccessAlert() {
    const { showRecreateSuccessAlert, recreateMessage } = this.state;

    return (
      <AmsAlert
        show={showRecreateSuccessAlert || !isEmpty(recreateMessage)}
        title="Manifest File Recreated"
        type="success"
        showConfirm
        text={recreateMessage}
        onConfirm={() => {
          this.setState({
            showRecreateSuccessAlert: false,
            recreateMessage: '',
          });
        }}
      />
    );
  }

  showGenerateAdhocWarning = () => {
    const { showGenerateAdHocWarningFlag } = this.state;

    return (
      <AmsAlert
        show={showGenerateAdHocWarningFlag}
        title="Generate Adhoc Sample"
        text="You are about to generate a new adhoc sample. Are you sure you want to continue?"
        type="info"
        showCancelButton
        confirmButtonColor={'#DD6B55'}
        confirmButtonText={'Yes'}
        cancelButtonText={'No'}
        onConfirm={() => {
          this.setState({ showGenerateAdHocWarningFlag: false });
          // Execute update process.
          this.generateAdhoc();
        }}
        onCancel={() => {
          this.setState({ showGenerateAdHocWarningFlag: false });
        }}
        onEscapeKey={() =>
          this.setState({ showGenerateAdHocWarningFlag: false })
        }
        onOutsideClick={() =>
          this.setState({ showGenerateAdHocWarningFlag: false })
        }
      />
    );
  };

  showFreezeSampleWarning = () => {
    const { showFreezeSampleWarningFlag } = this.state;

    return (
      <AmsAlert
        show={showFreezeSampleWarningFlag}
        title="Freeze Auto-generated CLASS Sample Process"
        text="You are about to freeze the auto-generated CLASS sample process. Are you sure you want to continue?"
        type="info"
        showCancelButton
        confirmButtonColor={'#DD6B55'}
        confirmButtonText={'Yes'}
        cancelButtonText={'No'}
        onConfirm={() => {
          this.setState({ showFreezeSampleWarningFlag: false });
          // Execute update process.
          this.freezeSample();
        }}
        onCancel={() => {
          this.setState({ showFreezeSampleWarningFlag: false });
        }}
        onEscapeKey={() =>
          this.setState({ showFreezeSampleWarningFlag: false })
        }
        onOutsideClick={() =>
          this.setState({ showFreezeSampleWarningFlag: false })
        }
      />
    );
  };

  showAdhocGenerateSuccessAlert = () => {
    const { showAdhocGenerateAlert, adhocMessage } = this.state;

    return (
      <AmsAlert
        show={showAdhocGenerateAlert || !isEmpty(adhocMessage)}
        title="Adhoc Class Samples Generated"
        type="success"
        showConfirm
        text={adhocMessage}
        onConfirm={() => {
          this.setState(
            {
              showAdhocGenerateAlert: false,
              adhocMessage: '',
            },
            () => {
              const reviewId = this.context.router.params.id;
              this.props.getClassSamplingReport({ reviewId });
            }
          );
        }}
      />
    );
  };

  showFreezeSampleSuccessAlert = () => {
    const { showFreezeSampleAlert, freezeSampleMessage } = this.state;

    return (
      <AmsAlert
        show={showFreezeSampleAlert || !isEmpty(freezeSampleMessage)}
        title="Auto-generated CLASS Sample Process Frozen"
        type="success"
        showConfirm
        text={freezeSampleMessage}
        onConfirm={() => {
          this.setState({
            showFreezeSampleAlert: false,
            freezeSampleMessage: '',
          });
        }}
      />
    );
  };

  handleFinalizeReviewClick() {
    this.setState({ showAlert: true });
  }

  handleSurveySelect(selectedSurveys) {
    this.setState({ selectedSurveys });
  }

  showResponseErrors() {
    const { responseErrors } = this.state;

    if (responseErrors && responseErrors.length)
      return (
        <Alert bsStyle="danger">
          <strong>Something went wrong!</strong>
          <ul>
            {responseErrors.map((errorObject, index) => (
              <li key={index}>
                {errorObject.message} code:(
                {errorObject.code})
              </li>
            ))}
          </ul>
        </Alert>
      );
  }

  render() {
    const { selectedReview } = this.props;

    const actionButtons = (
      <>
        <List.Item>
          <List.Content>{this.renderEditButton()}</List.Content>
        </List.Item>
      </>
    );

    return (
      <div className="review-detail-page">
        {this.showResponseErrors()}
        {this.showConfirmationAlert()}
        {this.showSuccessAlert()}
        {this.showManifestRecreateSuccessAlert()}
        {this.showAdhocGenerateSuccessAlert()}
        {this.showMoreClassSamplingReports()}
        {this.showGenerateAdhocWarning()}
        {this.showFreezeSampleWarning()}
        {this.showFreezeSampleSuccessAlert()}
        <ReviewLayout
          calendar
          title={formatReviewPageTitle(selectedReview)}
          actionButtons={actionButtons}
        >
          {this.renderReviewDetail()}
        </ReviewLayout>
        {/* Render child routes */}
        {this.props.children}
      </div>
    );
  }
}

ReviewDetailPage.propTypes = {
  reviewList: PropTypes.array.isRequired,
  selectedReview: PropTypes.object.isRequired,
  message: PropTypes.object.isRequired,
  finalizeSurveys: PropTypes.func.isRequired,
  recreateManifestFile: PropTypes.func.isRequired,
  fetchReviewEvidence: PropTypes.func.isRequired,
  fetchAmsLookup: PropTypes.func.isRequired,
  amsLookups: PropTypes.object.isRequired,
};

ReviewDetailPage.contextTypes = {
  router: PropTypes.object.isRequired,
};

function mapStateToProps(state) {
  return {
    currentUser: state.auth.user,
    reviewList: state.review.reviewList,
    message: state.message,
    selectedReview: state.review.selectedReview,
    reportDraftTemplate: state.report.reportDraftTemplate,
    classSamplingReportList: state.submissions.classSamplingReportList,
    report: state.report,
    amsLookups: state.lookups.amsLookups,
  };
}

export default connect(mapStateToProps, {
  fetchReviews,
  fetchReviewDetail,
  clearReviewDetail,
  finalizeReview,
  removeMessage,
  finalizeSurveys,
  recreateManifestFile,
  fetchClassReviewDetail,
  runAdHocSampleGenerate,
  fetchReportDraftTemplate,
  getClassSamplingReport,
  downloadClassSamplingReport,
  fetchReviewEvidence,
  reportSaveAction,
  fetchEmailNotifyFOMRequest,
  updateReviewStatus,
  submitToFOM,
  fetchReportStatusData,
  freezAdhocReport,
  surveyReportSaveAction,
  fetchAmsLookup,
})(ReviewDetailPage);
